import React, { useState } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';

export default function App() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const navLinks = [
    { to: '/', label: 'Главная' },
    { to: '/cars', label: 'Машины' },
    { to: '/customers', label: 'Клиенты' },
    { to: '/rentals', label: 'Аренды' },
    { to: '/expenses', label: 'Расходы' },
    { to: '/calendar', label: 'Календарь' },
    { to: '/reports', label: 'Отчёты' },
    { to: '/users', label: 'Пользователи' }, // ⬅️ Добавь это
  ];

  return (
    <div className="bg-zinc-950 text-white min-h-screen overflow-hidden flex">
      {/* 📋 Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-screen w-64 bg-zinc-900 p-4 space-y-2 z-40
        transform transition-transform duration-300 ease-in-out 
        ${menuOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`}
      >
        <div className="flex items-center justify-between md:block">
          <div className="text-xl font-semibold mb-4">Car Rental Manager</div>
          {/* ❌ Закрыть (только на мобилке) */}
          <button
            onClick={toggleMenu}
            className="text-2xl text-zinc-300 hover:text-white md:hidden"
          >

          </button>
        </div>

        <nav className="flex flex-col gap-2">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              onClick={closeMenu}
              className={`px-3 py-2 rounded hover:bg-zinc-800 transition-colors ${location.pathname === to ? 'bg-zinc-800' : ''
                }`}
            >
              {label}
            </Link>
          ))}
        </nav>
      </aside>

      {/* 🌍 Контент */}
      <main className="flex-1 min-h-screen p-4 md:p-6 overflow-y-auto transition-all duration-300 md:ml-[261px] md:pl-[15px]">
        {/* 🍔 Бургер на мобилке */}
        <div className="md:hidden flex items-center justify-between mb-4">
          <button
            onClick={toggleMenu}
            className="text-2xl text-zinc-300 hover:text-white"
          >
            ☰
          </button>
          <div className="text-lg font-semibold">Car Rental Manager</div>
        </div>

        <Outlet />
      </main>

      {/* 🔳 Затемнение при открытом меню */}
      {menuOpen && (
        <div
          onClick={closeMenu}
          className="fixed inset-0 bg-black/50 z-30 md:hidden transition-opacity"
        ></div>
      )}
    </div>
  );
}
